import "./PageLayout.css";
import { FC, useRef, useState } from "react";
import { BaseFooter } from "@/features/footer/layout/BaseFooter/BaseFooter.tsx";
import { BaseHeader } from "@/features/header/layout/BaseHeader/BaseHeader.tsx";
import { Outlet } from "react-router-dom";
import useDynamicTitle from "@/core/hooks/useDynamicTitle.ts";
import { MatomoTracker } from "@/features/utils/MatomoTracker.tsx";

export const PageLayout: FC = () => {
    useDynamicTitle();

    const [menuExpanded, setMenuExpanded] = useState(false);

    //set inert attribute on containers, so this part of the HTML document cannot be navigated via keyboard shortcuts while menu is open
    const contentRef = useRef<HTMLDivElement>(null);
    const footerRef = useRef<HTMLDivElement>(null);
    const headerLogoRef = useRef<HTMLDivElement>(null);
    const onMenuChange = (menuExpanded) => {
        if (menuExpanded){
            contentRef.current?.setAttribute("inert", "");
            footerRef.current?.setAttribute("inert", "");
            headerLogoRef.current?.setAttribute("inert", "");
        } else {
            contentRef.current?.removeAttribute("inert");
            footerRef.current?.removeAttribute("inert");
            headerLogoRef.current?.removeAttribute("inert");
        }
        setMenuExpanded(menuExpanded);
    };

    return (
        <>
            <MatomoTracker/>
            <div className="page-wrapper">
                <div className="header-wrapper">
                    <BaseHeader expanded={menuExpanded} onMenuChange={onMenuChange} headerLogoRef={headerLogoRef}/>
                </div>
                <div className="content-wrapper" ref={contentRef}>
                    <Outlet />
                </div>
                <div className="footer-wrapper" ref={footerRef}>
                    <BaseFooter />
                </div>
            </div>
        </>
    );
};
